import type { CurrencyCode } from "@/lib/apply-now/eligibility-constants";

/**
 * Currencies the calculator can model: one per market Wayflyer funds in
 * (see `getCurrencyCodeForCountryLabel`). EUR covers Ireland, Germany,
 * Spain, the Netherlands and Belgium; AUD also covers New Zealand.
 */
export const CALCULATOR_CURRENCIES = [
  "USD",
  "GBP",
  "EUR",
  "CAD",
  "AUD",
  "DKK",
  "SEK",
] as const satisfies readonly CurrencyCode[];

export type CalculatorCurrency = (typeof CALCULATOR_CURRENCIES)[number];

/**
 * Largest funding amount the calculator models, per currency. USD, GBP, EUR
 * and CAD run to 20m; AUD, DKK and SEK are the equivalent of €20m, rounded
 * to a clean figure, so the slider covers a comparable real range.
 */
export const AMOUNT_MAX_BY_CURRENCY: Record<CalculatorCurrency, number> = {
  USD: 20_000_000,
  GBP: 20_000_000,
  EUR: 20_000_000,
  CAD: 20_000_000,
  AUD: 35_000_000,
  DKK: 150_000_000,
  SEK: 225_000_000,
};

export function isCalculatorCurrency(
  value: string | null | undefined
): value is CalculatorCurrency {
  return (CALCULATOR_CURRENCIES as readonly string[]).includes(value ?? "");
}
